import React, { useState } from "react";
import { useParams } from "react-router";
import { Heading, Loader, Popup } from "uikit/components";
import { BackLink } from "components";
import { useFederationLoading } from "hooks/loading";
import Pagination from "uikit/components/Pagination/Pagination";
import math from "lodash";
import styles from "./FederationLoadingPage.module.styl";
import FederationLoadingView from "components/loading/FederationLoadingView/FederationLoadingView";
import { Flags, toShortDateStringLocale } from "utils";
import { useContextPerson } from "hooks/persons";

export default function FederationLoadingPage() {
    const pageSize = 20;

    const [payload, setPayload] = useState({ pageNumber: 1 });

    const { federationId } = useParams();
    const { flags, isLoading: isContextLoading } = useContextPerson();
    const { isLoading, data } = useFederationLoading(federationId, payload, {
        keepPreviousData: true,
    });

    const handlePageChange = (newPageNumber) => {
        setPayload((payload) => ({ ...payload, pageNumber: newPageNumber }));
    };

    if (isLoading || isContextLoading) {
        return (
            <Popup blockClickOnOverlay appearance="adaptive">
                <Loader
                    position={"margin-auto"}
                    text={"Подождите. Данные загружаются."}
                    testName="loader-text"
                />
            </Popup>
        );
    }

    if (data) {
        return (
            <>
                {!flags?.[Flags.HideDashboardBackButton] && (
                    <BackLink
                        to={`/federation-summary/${federationId}`}
                        text={"Назад"}
                        name={"back-federation-object-loading"}
                    />
                )}
                <Heading size={"h1"} className={styles.heading} name="federation-loading-title">
                    {data.federationData.name}: Загруженность c{" "}
                    {toShortDateStringLocale(data.reportDates.start)}. по{" "}
                    {toShortDateStringLocale(data.reportDates.end)}.
                </Heading>
                <FederationLoadingView sportObjectLoadings={data.sportObjectLoadings} />
                {data.count > pageSize && (
                    <Pagination
                        pageCount={math.ceil(data.count / pageSize)}
                        forcePage={payload.pageNumber}
                        onPageChange={handlePageChange}
                        className={styles.pagination}
                    />
                )}
            </>
        );
    }
}
